import React, { useContext, useEffect, useState } from 'react';
import AdminLayout from '../../components/admin-layout';
import { IoIosHelpCircleOutline } from 'react-icons/io';
import { BsCurrencyRupee } from 'react-icons/bs';
import { IoWallet } from 'react-icons/io5';
import { FiArrowRight } from 'react-icons/fi';
import { RiCashLine } from 'react-icons/ri';
import { FaCreditCard } from 'react-icons/fa';
import CreditUsage from '../../components/wallets/CreditUsage';
import { FiChevronLeft } from 'react-icons/fi';
import Subscription from '../../components/wallets/Subscription';
import MainOddsPopup from '../../components/common/oddsPopup/MainOddsPopup';
import { AppContext, walletContext } from '../../appContext';
import { HiOutlineArrowSmallLeft } from 'react-icons/hi2';
import {
  SendPayPageAuthApi,
  VerifyPayPageAuthApi,
  getCreditBasePrice,
  getCreditusedHisoryApi,
  getHospitalProfilebyId,
  getMonthlyDue,
  getProfilebyId,
  getUserApi,
  getcreditpurhcasegraph,
} from '../../apis';
import AmountDue from './AmountDue';
import MonthlyEarnings from './MonthlyEarnings';
import PayBill from '../../components/wallets/PayBill';
import ConfirmPopup from '../../components/confirmPopup/ConfirmPopup';
import VerifyConfirmation from '../../components/confirmPopup/verifyconfirmation';
import toast from 'react-hot-toast';
import CMHeader from '../../PageComponentData/Common/Pageheader';
import WalletIndexNav from '../../PageComponentData/wallet/Pagenav';
import Cookies from "js-cookie";

function WalletIndex() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { loggedInUser } = useContext(AppContext);
  // console.log(loggedInUser?.data?.hospitalProfile?.walletId?.balance);
  const [Loader, setLoader] = useState(false);
  const [balanceData, setbalanceData] = useState([]);
  const [balance, setbalance] = useState(0);
  const [monthlyDueData, setMonthlyDueData] = useState(null);
  const [consultationHistoryBlock, setConsultationHistoryBlock] = useState(
    false
  );
  console.log(balance);
  const getItem = async () => {
    try {
      const res = await getHospitalProfilebyId(
        loggedInUser?.data?.hospitalProfile?._id
      );
      if (res.status === 200) {
        console.log(res.data.hospitalProfile);
        setbalance(res?.data?.hospitalProfile?.walletId?.balance);
        console.log(res?.data?.hospitalProfile?.walletId?.balance);
        try {
          const res = await getcreditpurhcasegraph(
            loggedInUser?.data?.hospitalProfile?._id
          );
          if (res.status === 200) {
            console.log(res.data.CreditPurchasedHistory);
            setbalanceData(res.data.CreditPurchasedHistory);
          }
        } catch (error) {
          setLoader(false);
          console.log(error);
        }
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  useEffect(() => {
    if (loggedInUser?.data?.hospitalProfile?._id) {
      console.log("loggedInUser", loggedInUser)
      getItem();
    }
  }, [loggedInUser]);
  const accountCardBody = (
    <div>
      <p className="text-coalBlack font-medium py-2">choose account</p>
      <div className="my-4 grid grid-cols-1 gap-6 text-coalBlack">
        <div className="bg-lightBlue p-4 rounded-2xl ">
          <div className="inline-flex gap-3">
            <div>
              <FaCreditCard className="text-2xl" />
            </div>
            <div>
              <p className="font-medium">ICICI Debit card</p>
              <p className="font-medium text-sm text-navLink">0318-1608-2105</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  const [subscriptionBlock, setSubscriptionBlock] = useState(false);
  const [creditUsageBlock, setCreditUsageBlock] = useState(false);
  const [buyCreditBlock, setBuyCreditBlock] = useState(false);
  const handleBuyCreditBlock = () => {
    setBuyCreditBlock(!buyCreditBlock);
  };

  const toGetMonthlyDue = async (payload) => {
    try {
      const res = await getMonthlyDue(payload);
      if (res.status === 200) {
        console.log(res);
        setMonthlyDueData(res?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    const dateObj = new Date();
    const month = dateObj.getMonth() + 1;
    const year = dateObj.getFullYear();
    const payload = {
      hospitalId: loggedInUser?.data?.hospitalProfile?._id,
      month: month <= 9 ? '0' + month : month,
      year: year,
    };
    toGetMonthlyDue(payload);
  }, [loggedInUser]);
  function getDueMonth(prop) {
    const date = new Date();
    date.setMonth(prop - 1);
    return date.toLocaleString('en-US', { month: 'long' });
  }
  const completedCount = monthlyDueData?.TransactionRecord?.filter(
    (transaction) => transaction.consultation_id?.[0]?.status === "completed"
  ).length;
  const [verifyPage, setverifyPage] = useState(false);
  const TriggerPaymentPageOTP = async () => {
    try {
      const res = await SendPayPageAuthApi({ hospitalId: loggedInUser?.data?.hospitalProfile?._id, PageAccess: true });
      if (res.status === 200) {
        console.log(res);
        toast.success(res.data.message);
        setverifyPage(true)
      }
    } catch (error) {
      console.log(error);
      const message = error?.response?.data.message || error?.response?.statusText;
      toast.error(message, { id: "error" });
    }
  };
  const [isWrongOtp, setIsWrongOtp] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const VerifyPaymentPageOTP = async (otp) => {
    try {
      const res = await VerifyPayPageAuthApi({
        hospitalId: loggedInUser?.data?.hospitalProfile?._id,
        OTP: otp
      });
      if (res.status === 200) {
        console.log(res);
        // ✅ On successful verification, store cookie for 30 minutes
        Cookies.set('identity_verified', 'true', { expires: (1 / 96) }); // 15 minutes

        setisunlock(true);
        setIsWrongOtp(false);
        setErrorMsg("");
      }
    } catch (error) {
      console.log(error);
      const message = error.response.data.message || error.response.statusText;
      toast.error(message, { id: "error" });
      setIsWrongOtp(true);
      setErrorMsg(message);
    }
  };
  const [isunlock, setisunlock] = useState(true);
  useEffect(() => {
    pageloadcall()
  }, []);
  const pageloadcall = async () => {
    const getprofile = await getUserApi();
    console.log("get profile details", getprofile)
    if (getprofile?.status === 200) {
      console.log(getprofile)
      const verified = Cookies.get('identity_verified');
      const paylock = await getprofile?.data?.Profile?.hospitalProfile?.paylocktoggle;
      console.log("paylock", paylock)
      if (!verified && (paylock === 'true' || paylock)) {
        // 🚨 Not verified or cookie expired
        setisunlock(false);
      }
      else {
        setisunlock(true);
      }
    }

  }

  return (
    <walletContext.Provider value={[handleBuyCreditBlock]}>

      {
        isunlock ?
          <>
            <CMHeader headertxt={'Payments'} />
            <AdminLayout headerTxt={'Payments'}>
              <section className=" md:p-4 md:!pt-2 xl:p-5 xl:pb-0">

                {/* sm screen  start*/}
                <div className="lg:hidden mb-40">
                  <section className="mt-5 px-4">
                    <div className="bg-accent text-white p-4 rounded-xl   shadow-blue_dropshadow min-h-32 flex flex-col">
                      <div className="pb-6 flex">
                        <div className="inline-flex gap-2 items-center">
                          <IoWallet className="text-2xl text-white  m-auto  p-px rounded-full " />
                          <span className="headingText">
                            {getDueMonth(
                              new Date().getMonth() + 1 <= 9
                                ? 0 + new Date().getMonth() + 1
                                : new Date().getMonth() + 1
                            )}{' '}
                            Consultations
                          </span>
                        </div>
                        <span className="ms-auto headingText me-2">
                          {completedCount <= 9
                            ? '0' + completedCount
                            : completedCount}
                        </span>
                      </div>
                      <div className="flex items-center pt-5 mt-auto border-t border-t-px border-gray-300/75 relative">
                        <p className="highlightText ">
                          <BsCurrencyRupee className="me-px inline-block" />
                          {monthlyDueData?.TotalAmount || '0'}
                        </p>
                      </div>
                    </div>
                  </section>
                  <div className="">
                    <AmountDue />
                  </div>
                  <WalletIndexNav
                    state={consultationHistoryBlock}
                    setstate={setConsultationHistoryBlock}
                    title={"Recent Consultations"}
                  />
                  <WalletIndexNav
                    state={creditUsageBlock}
                    setstate={setCreditUsageBlock}
                    title={"view payments"}
                  />
                  <div className="fixed bottom-20 right-4 z-30">
                    <div
                      className="inline-flex gap-2 items-center ms-auto bg-accent rounded-xl text-white min-h-14 px-6 py-2 "
                      onClick={handleBuyCreditBlock}
                    >
                      <RiCashLine className="text-2xl" />
                      <button className="baseText !font-medium">Pay Amount</button>
                    </div>
                  </div>
                </div>
                {/* sm screen  end*/}

                {/* large devices start */}
                <div className=" hidden lg:grid-cols-12 gap-6 lg:grid my-3 ">
                  <div className="col-span-12  xl:col-span-8">
                    <section className="py-5 bg-white p-4 rounded-2xl  gap-x-4">
                      <div className='flex justify-between items-center mb-3'>
                        <p className="text-coalBlack capitalize headingText col-span-2">
                          overview
                        </p>
                        <div
                          className="gap-2 items-center ms-auto bg-accent rounded-lg text-white min-h-11 px-6 py-2 md:inline-flex hidden"
                          onClick={handleBuyCreditBlock}
                        >
                          <RiCashLine className="text-2xl" />
                          <button className="baseText ">Pay Amount</button>
                        </div>
                      </div>

                      <div className="bg-accent text-white p-4 rounded-xl   shadow-blue_dropshadow min-h-32 flex flex-col">
                        <div className="pb-6 flex">
                          <div className="inline-flex gap-2 items-center">
                            <IoWallet className="text-2xl text-white  m-auto  p-px rounded-full " />
                            <span className="headingText  ms-1">
                              {getDueMonth(
                                new Date().getMonth() + 1 <= 9
                                  ? 0 + new Date().getMonth() + 1
                                  : new Date().getMonth() + 1
                              )}{' '}
                              Consultations
                            </span>
                          </div>
                          <span className="ms-auto headingText me-2">
                            {completedCount <= 9
                              ? '0' + completedCount
                              : completedCount}
                          </span>
                        </div>
                        <div className="flex items-center pt-5 mt-auto border-t border-t-px border-gray-300/75 relative">
                          <p className="highlightText ">
                            <BsCurrencyRupee className="me-px inline-block" />
                            {monthlyDueData?.TotalAmount || '0'}
                          </p>
                        </div>
                      </div>
                    </section>


                    <section className=" bg-white rounded-2xl mt-4">
                      <CreditUsage />
                    </section>
                  </div>
                  <div className="col-span-12 hidden  lg:block max-h-screen xl:col-span-4">
                    <section className="h-full scrollbar overflow-y-scroll">
                      <div className="h-fit">
                        <AmountDue />
                      </div>
                      <div className="bg-white rounded-2xl overflow-y-auto  scrollbar">
                        <h1 className="text-coalBlack subHeadingText p-4 py-5 sticky top-0 bg-white border-b border-gray-100">
                          Recent Consultations
                        </h1>
                        <MonthlyEarnings data={monthlyDueData} />
                      </div>
                    </section>
                  </div>
                </div>
                {/* large devices end */}
                {buyCreditBlock && (
                  <PayBill closeFunction={handleBuyCreditBlock} />
                )}
                {/* select cards start */}
                {subscriptionBlock && (
                  <Subscription closeFunction={setSubscriptionBlock} />
                )}
                {creditUsageBlock && (
                  <div className="lg:hidden">
                    <MainOddsPopup>
                      <div className="min-h-screen h-full bg-white">
                        <CreditUsage closeFunction={setCreditUsageBlock} />
                      </div>
                    </MainOddsPopup>
                  </div>
                )}

                {/* select cards end */}
                {/* consultationHistoryBlock start  */}
                {consultationHistoryBlock && (
                  <div className="lg:hidden">
                    <MainOddsPopup>
                      <div className="min-h-screen h-screen bg-white overflow-y-auto scrollbar overscroll-contain pb-[152px]">
                        <header className="p-4 sticky top-0 bg-white z-40 border-b border-gray-100">
                          <div className="flex items-center">
                            <div className="inline-flex gap-1 items-center w-full">
                              <HiOutlineArrowSmallLeft
                                className="text-2xl text-coalBlack active:bg-sky-50 lg:hidden"
                                onClick={() => {
                                  setConsultationHistoryBlock(
                                    !consultationHistoryBlock
                                  );
                                }}
                              />
                              <p className="headingText text-coalBlack align-self-center capitalize">
                                Recent Consultations
                              </p>
                            </div>
                          </div>
                        </header>
                        <MonthlyEarnings data={monthlyDueData} />
                      </div>
                    </MainOddsPopup>
                  </div>
                )}
                {/* consultationHistoryBlock end */}
              </section>

            </AdminLayout>
          </>
          :
          <AdminLayout>
            <section className="md:p-4 xl:p-5 xl:pb-0 d-flex justify-center items-center">
              {
                loggedInUser?.data?.email &&
                <VerifyConfirmation
                  popupStatus={true}
                  email={loggedInUser?.data?.email}
                  onConfirm={() => { TriggerPaymentPageOTP() }}
                  handleClose={() => { alert("comming") }}
                  verifyPage={verifyPage}
                  onVerifyOtp={(otp) => { VerifyPaymentPageOTP(otp) }}
                  errorMsg={errorMsg}
                  setErrorMsg={setErrorMsg}
                  setIsWrongOtp={setIsWrongOtp}
                  isWrongOtp={isWrongOtp}
                  sendheader={
                    <p className="text-sm text-center text-gray-700">
                      To view this page, please verify your identity. <br />
                      Click <strong>"Send OTP"</strong> to receive a OTP  on {" "}

                    </p>
                  }
                  verifyheader={
                    <p className="text-sm text-center text-gray-700">
                      To access this page, please enter the otp sent to {" "}
                    </p>
                  }

                />
              }


            </section>
          </AdminLayout>

      }

    </walletContext.Provider>
  );
}

export default WalletIndex;
